import {Component} from "@angular/core";
import {AccessRoleSearchModel} from "../access-role-search.model";
import {AccessRoleEntityModel} from "../access-role-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-access-role-search-page",
    templateUrl: "./access-role-search-page.component.html",
    providers: [provideSearchModel(AccessRoleSearchModel), provideEntityModel(AccessRoleEntityModel)]
})
export class AccessRoleSearchPageComponent extends AbstractSearchPage {
}
